<template>
  <jade-box
    hasPadding
    class="eu-mt_5 eu-mb_3"
  >
    <jade-text
      class="eu-mb_2"
      color="neutral"
      variant="text-large"
      weight="semibold"
      >{{ $t('stepStatusTracker.title') }}
    </jade-text>

    <jade-text
      class="eu-mb_4"
      color="medium"
      variant="text-medium"
      weight="regular"
      >{{ $t('stepStatusTracker.description') }}
    </jade-text>

    <jade-status-tracker :items="items" />
  </jade-box>
</template>

<script>
import { JadeBox, JadeStatusTracker, JadeText } from '@/components/jade'
import { ITEMS_STATUS_TRACKER } from './items-status-tracker.list'
import { mapGetters } from 'vuex'
import StepStatusTrackerManager from './step-status-tracker.manager'

export default {
  name: 'StepStatusTracker',
  components: {
    JadeBox,
    JadeText,
    JadeStatusTracker
  },
  computed: {
    ...mapGetters(['accountId', 'merchantId']),
    items () {
      return new StepStatusTrackerManager(
        this.merchantId,
        this.accountId,
        ITEMS_STATUS_TRACKER
      )
        .get()
        .map(item => ({
          ...item,
          link: { ...item.link, label: this.$t(item.link.label) },
          label: this.$t(item.label),
          description: this.$t(item.description)
        }))
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "stepStatusTracker": {
      "title": "Você tem etapas pendentes para começar a vender",
      "description": "Confira abaixo seus itens pendentes e utilize os links com conteúdos de apoio para ajudar em cada etapa da ativação de sua conta.",
      "items": {
        "accreditation": {
          "label": "Credenciamento",
          "link": "Minhas taxas"
        },
        "dispute": {
          "label": "Acesso a dashboard",
          "link": "Saiba mais sobre a dash"
        },
        "store": {
          "label": "Integração com a loja",
          "link": "Confira a documentação"
        },
        "activation": {
          "label": "Ativação da conta",
          "description": "Após sua primeira venda*"
        }
      }
    }
  },
  "en-US": {
    "stepStatusTracker": {
      "title": "You have pending steps to start selling",
      "description": "Check your pending items below and use the links with supporting content to help with each step of activating your account.",
      "items": {
        "accreditation": {
          "label": "Accreditation",
          "link": "My fees"
        },
        "dispute": {
          "label": "Your dispute is under review",
          "link": "Learn more about dash"
        },
        "store": {
          "label": "Integration with the store",
          "link": "Check the documentation"
        },
        "activation": {
          "label": "Account activation",
          "description": "After your first sale*"
        }
      }
    }
  }
}
</i18n>
